import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useComponentConfig } from '@core/js/hooks/component/useComponentConfig';
import * as helpers from '@core/js/components/main/TopWinners/helpers';
import { useTopWinners } from '@theme/js/components/main/TopWinners/hooks/useTopWinners';
import { WinnerItem } from '../WinnerItem';
import { TABLE_ANIMATION_INTERVAL, TABLE_ITEM_HEIGHT } from '@theme/js/components/main/TopWinners/constants';
import { useUpdateTableHeight } from '@theme/js/components/main/TopWinners/hooks/useUpdateTableHeight';

import style from './MobileTable.scss';

export const MobileTable = () => {
    const { customMobileRow = 2 } = useComponentConfig();
    const allWinners = useTopWinners();
    const elRef = useRef(null);
    const tableItemRef = useRef(null);
    const [topWinners] = useState(helpers.getWinnersSelection({
        rowsAmount: customMobileRow, startIndex: 0, allWinners
    }));
    const [reversedWinners] = useState([...allWinners.reverse()]);
    const [itemHeight, setItemHeight] = useState(0);
    const [transform, setTransform] = useState(0);
    const [startPosition, setStartPosition] = useState(0);
    const [tableHeight, setTableHeight] = useState(0);

    const calculateTableHeight = useCallback((height) => {
        setTableHeight(height - itemHeight / 2);
    }, [setTableHeight, itemHeight]);

    const tableRef = useUpdateTableHeight(topWinners.length, tableItemRef, calculateTableHeight, setItemHeight);

    useEffect(() => {
        if (tableItemRef?.current) {
            const firstPosition = -itemHeight * allWinners.length;
            setTransform(firstPosition);
            setStartPosition(firstPosition);
        }
    }, [tableItemRef, allWinners, topWinners, itemHeight]);

    useEffect(() => {
        if (!customMobileRow) {
            return;
        }

        const intervalId = setInterval(() => {
            setTransform((prev) => {
                elRef.current.style.transitionDuration = '300ms';
                return prev + itemHeight;
            });
        }, TABLE_ANIMATION_INTERVAL);

        return () => clearInterval(intervalId);
    }, [allWinners, customMobileRow, itemHeight]);

    useEffect(() => {
        const newPosition = transform + itemHeight;

        if (newPosition >= itemHeight) {
            setTimeout(() => {
                elRef.current.style.transitionDuration = '0ms';
                setTransform(startPosition);
            }, 300);
        }
    }, [transform, allWinners, itemHeight, startPosition]);

    return (
        <div ref={tableRef} className={style.tableWrapper} style={{ height: `${tableHeight}px` }}>
            <div ref={elRef} style={{ transform: `translateY(${transform}px)` }}>
                {topWinners.map((topWinner, index) => (
                    <WinnerItem
                        tableItemRef={tableItemRef}
                        key={`${topWinner.id}${index}`}
                        {...topWinner}
                    />
                ))}
                {reversedWinners.map((topWinner, index) => (
                    <WinnerItem
                        tableItemRef={tableItemRef}
                        key={`${topWinner.id}${index}`}
                        {...topWinner}
                    />
                ))}
            </div>
            {topWinners.length > 1 &&
                <div className={style.shadow} style={{ height: `${TABLE_ITEM_HEIGHT.CUSTOM_MOBILE / 2}rem` }} />}
        </div>
    );
};
